import { useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import emailjs from 'emailjs-com'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const InquiryForm = () => {
    // Form state
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')

    // Error states
    const [nameError, setNameError] = useState('')
    const [emailError, setEmailError] = useState('')
    const [phoneError, setPhoneError] = useState('')
    const [captchaError, setCaptchaError] = useState('')

    // Captcha verification state
    const [verified, setVerified] = useState(false)

    function onChange(value) {
        console.log('Captcha value:', value)
        setVerified(!!value)
        setCaptchaError('')
    }

    const refform = useRef()

    // Name validation - only letters and min 3 characters
    const validateName = (value) => {
        const nameRegex = /^[A-Za-z\s]+$/
        if (!value) {
            setNameError('Name is required')
            return false
        } else if (value.length < 3) {
            setNameError('Name must be at least 3 characters')
            return false
        } else if (!nameRegex.test(value)) {
            setNameError('Name should contain only letters')
            return false
        } else {
            setNameError('')
            return true
        }
    }

    // Email validation
    const validateEmail = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!value) {
            setEmailError('Email is required')
            return false
        } else if (!emailRegex.test(value)) {
            setEmailError('Please enter a valid email address')
            return false
        } else {
            setEmailError('')
            return true
        }
    }

    // Phone validation
    const validatePhone = (value) => {
        if (!value) {
            setPhoneError('Phone number is required')
            return false
        } else {
            setPhoneError('')
            return true
        }
    }

    // Handle field blur events for validation
    const handleNameBlur = () => validateName(name)
    const handleEmailBlur = () => validateEmail(email)
    const handlePhoneBlur = () => validatePhone(phone)

    const sendForm = (e) => {
        e.preventDefault()

        // Validate all fields before submission
        const isNameValid = validateName(name)
        const isEmailValid = validateEmail(email)
        const isPhoneValid = validatePhone(phone)

        // Check captcha
        if (!verified) {
            setCaptchaError('Please verify that you are not a robot')
            return
        }

        // If all validations pass, submit the form
        if (isNameValid && isEmailValid && isPhoneValid) {
            // Create form data for emailjs
            const formData = new FormData(e.target)
            formData.append('name', name)
            formData.append('email', email)
            formData.append('phone_number', phone)
            formData.append('message', message)

            emailjs
                .sendForm('service_52cv4u2', '800homes', e.target, 'qLyy-QK10bQA32qAQ')
                .then((res) => {
                    console.log(res)
                    window.location.href = '/thank-you'
                })
                .catch((err) => {
                    console.log(err)
                })

            // Reset form
            setName('')
            setEmail('')
            setPhone('')
            setMessage('')
            e.target.reset()
        }
    }

    return (
        <>
            <section className="container-fluid bg-grey-2 rounded-0 border border-grey border-1 p-md-5 py-4">
                <div className="row justify-content-center align-items-center">
                    <div className="col-12">
                        <div className="">
                            <form
                                ref={refform}
                                onSubmit={sendForm}
                                id="contactForm"
                                method="POST"
                                action="#"
                                className=""
                            >
                                <div className="form-group mb-3">
                                    <input
                                        type="text"
                                        className={`form-control text-grey fs-ss-16 fw-300 ${nameError ? 'is-invalid' : ''}`}
                                        id="name"
                                        name="name"
                                        placeholder="Name *"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        onBlur={handleNameBlur}
                                        required
                                    />
                                    {nameError && <div className="invalid-feedback">{nameError}</div>}
                                </div>
                                <div className="form-group mb-3">
                                    <input
                                        type="email"
                                        className={`form-control text-grey fs-ss-16 fw-300 ${emailError ? 'is-invalid' : ''}`}
                                        id="email"
                                        name="email"
                                        placeholder="Email *"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onBlur={handleEmailBlur}
                                        required
                                    />
                                    {emailError && <div className="invalid-feedback">{emailError}</div>}
                                </div>
                                <div className="form-group mb-3">
                                    <PhoneInput
                                        country={'ae'}
                                        value={phone}
                                        onChange={(phone) => setPhone(phone)}
                                        onBlur={handlePhoneBlur}
                                        inputProps={{
                                            name: 'phone_number',
                                            id: 'phone_number',
                                            required: true,
                                            className: `w-100  bg-transparent rounded-0 border-bottom border-0 border-white text-grey fs-ss-16 fw-300 ps-5 ${phoneError ? 'is-invalid' : ''}`,
                                            placeholder: 'Phone Number *',
                                        }}
                                        containerStyle={{
                                            width: '100%',
                                        }}
                                        enableSearch={true}
                                        buttonStyle={{
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                        }}
                                        dropdownStyle={{
                                            width: '300px',
                                        }}
                                    />
                                    {phoneError && <div className="invalid-feedback d-block">{phoneError}</div>}
                                </div>
                                <div className="form-group mb-4">
                                    <textarea
                                        className="form-control text-grey fs-ss-16 fw-300"
                                        id="message"
                                        name="message"
                                        rows="3"
                                        placeholder="Message"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                    ></textarea>
                                </div>
                                <div className="">
                                    <ReCAPTCHA sitekey="6LdX3UgqAAAAAMWqmjHfeiVGKr_oLcfyYrNEu8KH" onChange={onChange} />
                                    {captchaError && <div className="text-danger mb-2">{captchaError}</div>}
                                    <button className="mt-4 text-center text-white fw-300 bg-ss-primary bg-hover-ss-primary rounded-0 border-0 text-ss-secondary fs-ss-16 px-3 py-ss-2 w-100">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default InquiryForm
